import {
  createEntityAdapter,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { RootState } from 'src/store/index';

export type State = {
  loading: boolean;
};

export const adapter = createEntityAdapter<Model.Question>({
  selectId: (model) => model.id,
});

const { reducer, actions } = createSlice({
  name: 'module_quiz',
  initialState: adapter.getInitialState<State>({ loading: false }),
  reducers: {
    updateEntities(state, action: PayloadAction<Model.Question[]>) {
      adapter.upsertMany(state, action);
    },
    updateEntity(state, action: PayloadAction<Model.Question>) {
      adapter.upsertOne(state, action);
    },
    removeEntity(state, action: PayloadAction<Model.Question>) {
      adapter.removeOne(state, action.payload.id);
    },
    updateLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    retry(state, action: PayloadAction<{ class_topic_id: string }>) {
      const moduleQuiz = state.ids.map((id) => state.entities[id]);
      const currentQuizzes = moduleQuiz.filter(
        (q) => q?.class_topic_id === action.payload.class_topic_id,
      );

      adapter.updateMany(
        state,
        currentQuizzes.map((q) => ({
          id: q?.id!,
          changes: { user_answer: null },
        })),
      );
    },
  },
});

export const selector = adapter.getSelectors(
  (state: RootState) => state.model.module_quiz,
);

export const selectModuleQuizByClassTopicId = createSelector(
  selector.selectAll,
  (state: RootState, class_topic_id: string) => class_topic_id,
  (quiz, class_topic_id) => {
    const quizzes = quiz.filter(
      (q) => q.class_topic_id === class_topic_id && !q.class_topic_content_id,
    );

    return quizzes.sort((a, b) => (a.sequence > b.sequence ? 1 : -1));
  },
);

export { reducer };
export default actions;
